var map = {
	"./minImages/1.jpg": "9e84",
	"./minImages/枪王射击.jpg": "89a5",
	"./minImages/沙漠球球960x1004.jpg": "2f00",
	"./minImages/超级坦克王.jpg": "09f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19d5";